export default "__VITE_ASSET__BBI3U_XI__"